import React, {useEffect, useRef, useState} from 'react';
import './globalCommunitySection.scss';
import ScrollCounter from "../../../../components/scrollCounter/ScrollCounter";
import AnimateLine from "./components/AnimateLine";

const GlobalCommunitySection = () => {
	const [isVisible, setIsVisible] = useState(false);
	const [visibleElements, setVisibleElements] = useState([false, false, false]);
	const elementRef = useRef(null);
	const [width, setWidth] = useState(window.innerWidth);
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				if (entries[0].isIntersecting) {
					setIsVisible(true);
					observer.disconnect();
				}
			},
			{ threshold: 0.2 }
		);

		if (elementRef.current) {
			observer.observe(elementRef.current);
		}

		return () => {
			if (observer && elementRef.current) {
				observer.unobserve(elementRef.current);
			}
		};
	}, []);

	useEffect(() => {
		if (isVisible) {
			visibleElements.forEach((_, index) => {
				setTimeout(() => {
					setVisibleElements((prev) =>
						prev.map((val, i) => (i === index ? true : val))
					);
				}, index * 600);
			});
		}
	}, [isVisible]);

	return (
		<div className="globalCommunity" ref={elementRef}>
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="globalCommunity__title">
				<img
					src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/GroupPeople.svg`}
					alt={'Group'}
					className={`title-img fade-in ${visibleElements[0] ? 'visible' : ''}`}
				/>
				<div className="globalCommunity__title_text">
					<h2>Join our growing <br/> global <span className="globalCommunity__title_text_community">community</span></h2>
					<div
						className={`globalCommunity__latest_updates fade-in ${
							visibleElements[1] ? 'visible' : ''
						}`}
					>
						<div className="globalCommunity__latest_updates_text">
							<span>Keep up with the latest updates</span>
						</div>
						<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/${width > 1440 ? 'DottedArrow' : 'DottedArrowAdaptive'}.svg`}  alt={'Dotted arrow'}/>
					</div>
				</div>
				<div
					className={`globalCommunity__title_lifehacks fade-in ${
						visibleElements[2] ? 'visible' : ''
					}`}
				>
					<div className="globalCommunity__title_lifehacks_img">
						<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/Idea.svg`}  alt={'Idea'}/>
					</div>
					<span>Learn the lifehacks</span>
				</div>
			</div>
			<div className="globalCommunity__line">
				<AnimateLine />
			</div>
			<div className="globalCommunity__socials">
				<div className="globalCommunity__socials_item twitter">
					<div className="globalCommunity__socials_item_img twitter">
						<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/twitter.svg`}  alt={'Twitter'}/>
					</div>
					<div className="globalCommunity__socials_item_info">
						<ScrollCounter endNumber={63700} time={1000} postfix={'k'} useOneDecimal />
						<p>followers</p>
					</div>
				</div>

				<div className="globalCommunity__socials_item discord">
					<div className="globalCommunity__socials_item_img discord">
						<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/discord.svg`}  alt={'Discord'}/>
					</div>
					<div className="globalCommunity__socials_item_info">
						<ScrollCounter endNumber={33700} time={1000} postfix={'k'} useOneDecimal />
						<p>followers</p>
					</div>
				</div>

				<div className="globalCommunity__socials_item youtube">
					<div className="globalCommunity__socials_item_img youtube">
						<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/youtube.svg`}  alt={'Youtube'}/>
					</div>
					<div className="globalCommunity__socials_item_info">
						<ScrollCounter endNumber={1020} time={800} postfix={'k'} useTwoDecimals />
						<p>followers</p>
					</div>
				</div>

				<div className="globalCommunity__socials_item telegram">
					<div className="globalCommunity__socials_item_img telegram">
						<img src={`${process.env.PUBLIC_URL}/assets/images/globalCommunity/telegram.svg`}  alt={'Telegram'}/>
					</div>
					<div className="globalCommunity__socials_item_info">
						<ScrollCounter endNumber={2700} time={850} postfix={'k'} useOneDecimal />
						<p>followers</p>
					</div>
				</div>

			</div>
		</div>
	);
};

export default GlobalCommunitySection;